<script setup lang="ts">
const isMenuOpen = ref(false)
const sbApi = useStoryblokApiV2()

const data = (await sbApi.getStories<{ content: any; slug: 'navigation' | 'footer' }>({
  by_slugs: ['layout/*'],
})).stories

useStoryblokBridge()
</script>

<template>
  <div>
    <TheNavigation v-model:is-menu-open="isMenuOpen" v-bind="data.find(item => item.slug === 'navigation')?.content" />
    <NuxtPage />
    <TheFooter v-bind="data.find(item => item.slug === 'footer')?.content" />
  </div>
</template>
